const jobMonitoringConstants = {
  LIMIT_SEARCH_DAYS: 32,
};

export default jobMonitoringConstants;
